<div class="anti-ragging-page">
  <app-header-style-seven></app-header-style-seven>

  <section class="page-shell anti-ragging-shell">
    <div class="custom-container">
      <div class="content-shell anti-ragging-content-shell">
        <!-- HERO -->
        <header class="page-hero">
          <span class="page-kicker">Student Safety</span>
          <h1>Anti-Ragging Committee</h1>
          <p>
            Institutional anti-ragging mechanisms, committee members, squad
            members, and complaint submission for student safety and compliance.
          </p>
        </header>

        <!-- INTRO -->
        <section
          class="info-card"
          [class.dark-experience-area]="themeService.isDark()"
        >
          <div class="info-copy">
            <p>
              All India Council for Technical Education (AICTE) has been
              proactive in addressing the issue of ragging in technical
              institutions and has provided specific guidelines and instructions
              to prevent and combat ragging. The AICTE has issued comprehensive
              regulations titled “AICTE Regulations on Curbing the Menace of
              Ragging in AICTE Approved Technical Institutions, 2009.”
            </p>
            <p>
              These regulations provide detailed guidelines and instructions to
              institutions to prevent, prohibit, and eliminate ragging.
              Institutions will submit compliance reports regarding anti-ragging
              measures to the AICTE every academic year. This includes
              information about the establishment and functioning of anti-ragging
              committees and squads.
            </p>
            <p>
              Institutions are mandated to establish anti-ragging committees at
              the institution level. Anti-ragging squads are also set up to
              conduct surprise checks and patrols in vulnerable areas.
            </p>
          </div>
        </section>

        <!-- COMMITTEE -->
        <section class="panel-card">
          <div class="panel-head">
            <div>
              <span class="panel-tag">Institution Level</span>
              <h2>Anti-Ragging Committee</h2>
            </div>
            <a
              class="pdf-link"
              href="assets/img/pdf/MOM-Anti Ragging Committee.pdf"
              target="_blank"
              rel="noopener"
            >
              Open PDF
            </a>
          </div>

          <div class="row g-4 align-items-start">
            <div class="col-lg-4 col-md-12">
              <div class="pdf-card">
                <a
                  href="assets/img/pdf/MOM-Anti Ragging Committee.pdf"
                  target="_blank"
                  rel="noopener"
                >
                  <img
                    src="assets/img/pdf/MOM-Anti-Ragging-Committee1.jpg"
                    alt="Anti-Ragging Committee PDF preview"
                    loading="lazy"
                    class="pdf-image"
                  />
                </a>
                <div class="pdf-caption">Committee resolution / PDF preview</div>
              </div>
            </div>

            <div class="col-lg-8 col-md-12">
              <div class="table-wrap">
                <table class="table committee-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Position</th>
                      <th>Category</th>
                      <th>Occupation</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let m of committeeMembers; trackBy: trackBySlno">
                      <td>{{ m.slno }}</td>
                      <td>{{ m.name }}</td>
                      <td>{{ m.position }}</td>
                      <td>{{ m.category }}</td>
                      <td>{{ m.occupation }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>

        <!-- SQUAD -->
        <section class="panel-card">
          <div class="panel-head">
            <div>
              <span class="panel-tag">Monitoring Team</span>
              <h2>Anti-Ragging Squad</h2>
            </div>
          </div>

          <div class="row g-4 align-items-start">
            <div class="col-lg-4 col-md-12">
              <div class="pdf-card">
                <img
                  src="assets/img/pdf/MOM-Anti-Ragging-Committee.jpg"
                  alt="Anti-Ragging Squad PDF preview"
                  loading="lazy"
                  class="pdf-image"
                />
                <div class="pdf-caption">Squad resolution / PDF preview</div>
              </div>
            </div>

            <div class="col-lg-8 col-md-12">
              <div class="table-wrap">
                <table class="table committee-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Designation</th>
                      <th>Post</th>
                      <th>Contact Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let m of squadMembers; trackBy: trackBySlno">
                      <td>{{ m.slno }}</td>
                      <td>{{ m.name }}</td>
                      <td>{{ m.designation }}</td>
                      <td>{{ m.post }}</td>
                      <td>
                        <a [href]="'tel:' + m.contact">{{ m.contact }}</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>

        <!-- COMPLAINT FORM -->
        <section
          class="students-feedback-form-area complaint-shell"
          [class.dark-students-feedback-form-area]="themeService.isDark()"
        >
          <div class="students-feedback-form">
            <div class="form-header">
              <h3>Anti-Ragging Complaint Form</h3>
              <a
                href="https://www.fmcet.ac.in/backend/anti_ragging/viewComplaints.php"
                target="_blank"
                rel="noopener"
                class="view-btn"
              >
                View Complaints
              </a>
            </div>

            <div *ngIf="submitSuccess" class="alert alert-success" role="alert">
              {{ submitMessage }}
            </div>

            <div *ngIf="submitError" class="alert alert-danger" role="alert">
              {{ submitMessage }}
            </div>

            <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate>
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <input
                      name="name"
                      [(ngModel)]="formData.name"
                      required
                      maxlength="100"
                      type="text"
                      class="form-control"
                      placeholder="Your name*"
                    />
                    <small class="text-danger" *ngIf="f.submitted && !formData.name">
                      Name is required
                    </small>
                    <span class="label-title"><i class="bx bx-user"></i></span>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <input
                      name="department"
                      [(ngModel)]="formData.department"
                      required
                      maxlength="100"
                      type="text"
                      class="form-control"
                      placeholder="Department*"
                    />
                    <small class="text-danger" *ngIf="f.submitted && !formData.department">
                      Department is required
                    </small>
                    <span class="label-title"><i class="bx bx-home"></i></span>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <input
                      name="gender"
                      [(ngModel)]="formData.gender"
                      required
                      maxlength="20"
                      type="text"
                      class="form-control"
                      placeholder="Gender*"
                    />
                    <small class="text-danger" *ngIf="f.submitted && !formData.gender">
                      Gender is required
                    </small>
                    <span class="label-title"><i class="bx bx-user-pin"></i></span>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <input
                      name="year_of_study"
                      [(ngModel)]="formData.year_of_study"
                      required
                      maxlength="20"
                      type="text"
                      class="form-control"
                      placeholder="Year of Study*"
                    />
                    <small class="text-danger" *ngIf="f.submitted && !formData.year_of_study">
                      Year of Study is required
                    </small>
                    <span class="label-title"><i class="bx bx-calendar"></i></span>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <input
                      name="complaint_summary"
                      [(ngModel)]="formData.complaint_summary"
                      required
                      maxlength="255"
                      type="text"
                      class="form-control"
                      placeholder="State your complaint*"
                    />
                    <small class="text-danger" *ngIf="f.submitted && !formData.complaint_summary">
                      Complaint summary is required
                    </small>
                    <span class="label-title"><i class="bx bx-message-alt-detail"></i></span>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <input
                      name="incident_date"
                      [(ngModel)]="formData.incident_date"
                      required
                      type="date"
                      class="form-control"
                    />
                    <small class="text-danger" *ngIf="f.submitted && !formData.incident_date">
                      Incident date is required
                    </small>
                    <span class="label-title"><i class="bx bx-calendar-event"></i></span>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12">
                  <div class="form-group">
                    <textarea
                      name="description"
                      [(ngModel)]="formData.description"
                      cols="30"
                      rows="5"
                      class="form-control"
                      placeholder="Write something here (Optional)"
                    ></textarea>
                    <span class="label-title"><i class="bx bx-edit"></i></span>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12">
                  <label class="consent">
                    <input
                      type="checkbox"
                      name="declaration_confirmed"
                      [(ngModel)]="formData.declaration_confirmed"
                      required
                    />
                    <span>
                      I have rechecked the form and confirm that all the details are
                      correct. I know if information is wrong I am liable for a
                      punishable action.
                    </span>
                  </label>

                  <small class="text-danger" *ngIf="f.submitted && !formData.declaration_confirmed">
                    Please confirm the declaration
                  </small>
                </div>

                <div class="col-lg-12 col-md-12 mt-3">
                  <button type="submit" class="default-btn" [disabled]="submitting">
                    <i class="bx bx-paper-plane icon-arrow before"></i>
                    <span class="label">{{ submitting ? 'Submitting...' : 'Send Message' }}</span>
                    <i class="bx bx-paper-plane icon-arrow after"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </section>
      </div>
    </div>
  </section>
</div>